export function formatDate(start: string, end: string): string {
    const option: Intl.DateTimeFormatOptions = {month: 'long', year: '2-digit'};
    const format = (dateStr: string) => {
      const formatted = new Date(dateStr).toLocaleDateString('nb-NO', option);
      return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    }
    return `${format(start)} - ${format(end)}`;
}

export function formatSingleDate(dateStr: string) {
    const date = new Date(dateStr);

    const fullFormat = date.toLocaleDateString('nb-NO', {
        month: 'long',
        year: '2-digit',
    });
    const capitalizedFull = fullFormat.charAt(0).toUpperCase() + fullFormat.slice(1);

    const year = date.getFullYear().toString();
    const monthFull = date.toLocaleDateString('nb-NO', { month: 'long' });
    const monthShort = date.toLocaleDateString('nb-NO', { month: 'short' });

    return {
        full: capitalizedFull,
        year,
        monthFull: monthFull.charAt(0).toUpperCase() + monthFull.slice(1),
        monthShort: monthShort.charAt(0).toUpperCase() + monthShort.slice(1),
    };
}
